import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		image: PropTypes.string,
		url: PropTypes.string
	};

    render() {

		return (
	 		<div className="mbot20">
	 			<img src={this.props.image} className="img-responsive" />
 			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/PreviewParts/ImagePreview.jsx